import React from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "consts";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PageMain } from "components/molecules";
import { useToaster } from "utils";
import { ksefApi } from "api/ksef";
import { KSeFIntegrationForm, KSeFIntegrationFormValues } from "./KSeFIntegrationForm";

export const KSeFAddPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: KSeFIntegrationFormValues) => {
    try {
      const response = await ksefApi.create(data);
      showSuccess("Dodano nową integrację KSeF");
      navigate(routes.KSEF_EDIT(response.data.id.toString()));
    } catch (e) {
      showError("Nie udało się dodać integracji KSeF");
      console.error(e);
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "KSeF", path: routes.KSEF }, { title: "Nowa integracja" }]}
        headerText="Nowa integracja KSeF"
      />
      <KSeFIntegrationForm onSubmit={onSubmit} />
    </PageMain>
  );
};
